import { deepDive } from '@/mocks/homeData';

export default function DeepDiveSection() {
  return (
    <section id="deepdive" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <aside className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-accent-700">
                <i className="ri-quill-pen-line"></i>
                {deepDive.eyebrow}
              </span>
              <div className="mt-6 overflow-hidden rounded-lg border border-foreground-950/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20old%20newspapers%2C%20handwritten%20notebooks%20and%20a%20magnifying%20glass%20on%20a%20warm%20cream%20desk%2C%20vermillion%20red%20thread%20connecting%20clippings%2C%20moody%20editorial%20research%20aesthetic&width=1200&height=900&seq=chigua-deepdive-01&orientation=landscape"
                  alt="深度观察：美日奇闻故事的生成方式研究配图"
                  title="深度观察 · 美日吃瓜"
                  className="h-64 w-full object-cover object-top md:h-80"
                />
              </div>
              <dl className="mt-6 space-y-3 rounded-lg border border-foreground-950/10 bg-background-100 p-5 text-sm">
                <div className="flex items-center justify-between">
                  <dt className="text-foreground-500">撰稿</dt>
                  <dd className="text-foreground-900">{deepDive.author}</dd>
                </div>
                <div className="flex items-center justify-between">
                  <dt className="text-foreground-500">发布</dt>
                  <dd className="text-foreground-900">{deepDive.date}</dd>
                </div>
                <div className="flex items-center justify-between">
                  <dt className="text-foreground-500">阅读时长</dt>
                  <dd className="text-foreground-900">约 {deepDive.readTime} 分钟</dd>
                </div>
              </dl>
            </div>
          </aside>

          <div className="lg:col-span-7">
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              {deepDive.title}
            </h2>
            <p className="mt-5 border-l-2 border-primary-500 pl-4 text-sm leading-8 text-foreground-600 md:text-base">
              {deepDive.dek}
            </p>

            <div className="mt-8 space-y-6">
              {deepDive.paragraphs.slice(0, 3).map((para, i) => (
                <p key={i} className="text-sm leading-9 text-foreground-800 md:text-base">
                  {para}
                </p>
              ))}
            </div>

            <blockquote className="my-9 rounded-lg bg-secondary-50 p-6 md:p-8">
              <i className="ri-double-quotes-l text-2xl text-secondary-500"></i>
              <p className="mt-3 font-heading text-lg font-semibold leading-relaxed text-secondary-900 md:text-xl">
                {deepDive.pullQuote}
              </p>
            </blockquote>

            <div className="space-y-6">
              {deepDive.paragraphs.slice(3).map((para, i) => (
                <p key={i} className="text-sm leading-9 text-foreground-800 md:text-base">
                  {para}
                </p>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-3 border-t border-foreground-950/10 pt-8">
              <span className="text-sm text-foreground-500">继续阅读：</span>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-800 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
              >
                <i className="ri-question-answer-line"></i>
                关于内容来源的常见问题
              </a>
              <a
                href="#subscription"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-send-plane-line"></i>
                订阅每周合集
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}